// src/components/routing/Keycloak.js
import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAKURL,
  realm: process.env.REACT_APP_KEYCLOAKREALM,
  clientId: process.env.REACT_APP_KEYCLOAKCLIENTID
};

// Create keycloak instance
const keycloak = new Keycloak(keycloakConfig);

// Track initialization status
let isInitializing = false;

export const initKeycloak = () => {
  return new Promise((resolve, reject) => {
    // Prevent multiple simultaneous initializations
    if (isInitializing) {
      console.log('Initialization already in progress');
      return resolve(false);
    }

    // If already authenticated, resolve immediately
    if (keycloak.authenticated) {
      console.log('Already authenticated');
      return resolve(true);
    }

    isInitializing = true;

    const initConfig = {
      onLoad: 'login-required',
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
      pkceMethod: 'S256',
      enableLogging: true,
      checkLoginIframe: false,
      scope: 'openid profile email',
      responseMode: 'query'
    };

    console.log('Starting Keycloak initialization...');

    keycloak
      .init(initConfig)
      .then(authenticated => {
        console.log('Keycloak initialized:', authenticated);
        isInitializing = false;
        
        if (authenticated) {
          // Store tokens
          sessionStorage.setItem('keycloak-token', keycloak.token);
          resolve(true);
        } else {
          resolve(false);
        }
      })
      .catch(error => {
        console.error('Keycloak init error:', error);
        isInitializing = false;
        reject(error);
      });
  });
};

// Token refresh handler
keycloak.onTokenExpired = () => {
  console.log('Token expired, attempting refresh');
  keycloak.updateToken(70)
    .then(refreshed => {
      if (refreshed) {
        console.log('Token refreshed successfully');
        sessionStorage.setItem('keycloak-token', keycloak.token);
      }
    })
    .catch(error => {
      console.error('Token refresh failed:', error);
      // Force new login
      keycloak.login();
    });
};

export default keycloak;